import search from './search.js';
import credits from './credits.js';
import subscribe from './subscribe.js';
import product from './product.js';
import library from './library.js';
import checkout from './checkout.js';

// const languageRegex = process.env.VUE_APP_LANGUAGE_CODES.split(',').join('|');

export default [
  ...checkout,
  ...credits,
  ...subscribe,
  ...product,
  ...library,
  ...search,
  {
    path: '*',
    // path: `/:lang(${languageRegex})?/`,
    name: 'not-found',
    component: () => import(/* webpackChunkName: "not-found" */ '@/views/NotFound.vue'),
  },
];
